declare global {
  interface Window {
    UTIL_ENVIRONMENT_OVERRIDE?: 'local' | 'ci' | 'accept' | 'production'
  }
}

export const isAccept = (hostname: string = window.location.hostname): boolean => {
  if (window.UTIL_ENVIRONMENT_OVERRIDE) {
    return window.UTIL_ENVIRONMENT_OVERRIDE === 'accept'
  }
  return hostname.includes('accept')
}

export const isProd = (hostname: string = window.location.hostname): boolean =>
  hostname?.includes('my.dhlparcel') || hostname?.includes('my.dhlecommerce')
